import { Config } from 'config/envConfig';
import React, { useEffect, useState, useCallback, useMemo } from 'react';
import { useLocation } from 'react-router';
import axios from '../utils/axiosConfig';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { ExtractData } from './ExtractData';
import {
    OrganizationAccessOptions,
    Platforms,
    ProcessType,
    TaskProgressType,
} from '@quyva/common';
import {
    faFolderPlus,
    faFolderOpen,
    faFolderClosed,
    faFileCirclePlus,
    faTrash,
    faFolder,
    faCaretUp,
    faCaretDown,
    faCaretLeft,
    faShare,
    faEllipsisV,
    faChartLine,
    faDownload,
    faSync,
    faDatabase,
    faArrowsToDot,
    faG,
    faTable,
    faTableColumns,
    faUpload,
    faThumbTack,
    faBuildingCircleCheck,
    faPlus,
    faSort,
    faSortAlphaDown,
    faSortAmountDown,
    faFileExport,
    faEnvelope,
    faGlobe,
    faEnvelopeOpen,
    faSliders,
    faLink,
    faQuestionCircle,
    faLayerGroup,
    faProjectDiagram,
    faPenToSquare,
    faUsers,
} from '@fortawesome/free-solid-svg-icons';
import { message } from 'antd';
import 'react-reflex/styles.css';
import { ReflexContainer, ReflexElement } from 'react-reflex';
import QuestionsModal from './questions/questionsModal';
import AddNewRepo from './addNewRepo';
import AddContentToRepo from './AddContentToRepo';
import {
    alert,
    AlertType,
    ConfirmModal,
    Dropdown,
    LoadingView,
    Modal,
    SearchFilterInput,
} from '@quyva/shared-ui';
import { Button } from '@quyva/shared-ui';
import { Brand } from './brand';
import { UserDetailAndAction } from './userDetailAndAction';
import { ShareRepository } from './shareRepository/shareRepository';
import { UserAccessOptions } from '@quyva/common';
import { RepositoryStats } from './repositoryStats';
import { RepoStatsDB } from './RepoStatsDB';
import { FilesListView } from './filesListView';
import { Mode } from '@quyva/common';
import { RepoType } from '@quyva/common';
import { BatchType } from '@quyva/common';
import { useGlobalCredits } from '../context/GlobalStateContext';
import { MODE } from '../enums';
import { getUrl } from './pdfDisplay/utils';
import { ProductMappingWorkspace } from './productMappings';
import { useRef } from 'react';
import { useGoogleLogin } from '@react-oauth/google';
import {
    GOOGLE_TOKEN_TIMEOUT_MS,
    getOneDriveAccessToken,
    prepareOneDriveAuth,
} from '../utils/cloudAuth';
import TemplateComponent from './defaulttemplate';
import ExtractSupportInfo from './ExtractSupportInfo';
import { RepositoryWebAccessSettings } from './RepositoryWebAccessSettings';
import {
    ChatsFeatures,
    Features,
    OtherFeatures,
    isFeatureEnabled,
} from '@quyva/common';
import { useFeatureFlags } from '../context';
import { faTelegram, faWhatsapp } from '@fortawesome/free-brands-svg-icons';
import { TelegramFormView, TelegramDetails } from './telegram';
import { TelegramSocketEvent } from './telegram/enums';
import { WhatsAppCard } from './whatsapp/WhatsAppCard';
import ConfigureRepo from './ConfigureRepo';
import { EmailInterface } from './emailInterface';
import VirtualRepositoryModal from './VirtualRepositoryModal';

const FileDownload = require('js-file-download');

const Sidebar = (props) => {
    const user = JSON.parse(localStorage.getItem('current'));

    const {
        chatrepofunction,
        set_fine_tuned,
        fileToChat,
        setFileToChat,
        isAdmin,
        setIsAdmin,
        mode,
        togglePdfVisibility,
        templateList,
        fetchDownloadList,
        workOnRepo,
        setWorkOnRepo,
        planName,
        onBatchOpen,
    } = props;

    const safeSetIsAdmin = (val) => {
        if (typeof setIsAdmin === 'function') {
            setIsAdmin(val);
        }
    };

    const itemRefs = useRef([]);
    const virtualRepoRefreshRef = useRef(null);
    const { featureFlagsData } = useFeatureFlags();
    const [scrollTo, setScrollTo] = useState(null);
    const [addNewMode, setAddNewMode] = useState(false);
    const [repoDetails, setRepoDetails] = useState([]);
    const [updateCloudRepo, setUpdateCloudRepo] = useState(false);
    const [addContentMode, setAddContentMode] = useState(false);
    const [deleteMode, setDeleteMode] = useState(false);
    const [toDelete, setToDelete] = useState({});
    // Pre-deletion impact (Telegram bots/groups, email inboxes, dashboards,
    // and sub-repos) shown in the delete-confirmation warning. Varies per repo.
    const [deleteImpact, setDeleteImpact] = useState(null);
    const [deleteImpactLoading, setDeleteImpactLoading] = useState(false);
    const [toShare, setToShare] = useState(null);
    const [productMappingInitialMode, setProductMappingInitialMode] =
        useState(false);
    const [toRepoWebAccess, setToRepoWebAccess] = useState(null);
    const [sharedRepos, setSharedRepos] = useState([]);
    const [globalRepos, setGlobalRepos] = useState([]);
    const [masterAgentRepos, setMasterAgentRepos] = useState([]);
    const [viewSharingModal, setViewSharingModal] = useState(false);
    const [toViewStats, setToViewStatus] = useState(null);
    const [viewStatsModal, setViewStatsModal] = useState(false);
    const [viewProductMappingModal, setViewProductMappingModal] =
        useState(false);
    const [viewRepoWebAccessModal, setViewRepoWebAccessModal] = useState(false);
    const [viewRepodb, setViewRepodb] = useState(false);
    const [addFileToRepo, setAddFileToRepo] = useState(null);
    const [cloudInfo, setCloudInfo] = useState(null);
    const [chat_selected, set_chat_selected] = useState(false);
    const [chatting_with_id, set_chatting_with_id] = useState('');
    const [allReposFilesData, setAllReposFilesData] = useState(new Map());
    const [isLoading, setIsLoading] = useState(false);
    const [loadingText, setLoadingText] = useState('');
    const [isDropdownOpen, setIsDropdownOpen] = useState(false);
    const [repoSearch, setRepoSearch] = useState('');
    const { transactionMode, setTransactionMode } = useGlobalCredits();
    const [closeDropdownSignal, setCloseDropdownSignal] = useState(false);
    const [repoProductMappings, setRepoProductMappings] = useState(null);
    const [productRepoMappings, setProductRepoMappings] = useState(null);
    const [repoHasFileProductMappings, setRepoHasFileProductMappings] =
        useState(null);
    const [
        productMappingHasUnsavedChanges,
        setProductMappingHasUnsavedChanges,
    ] = useState(false);
    const [
        confirmCloseProductMappingModal,
        setConfirmCloseProductMappingModal,
    ] = useState(false);

    const [repoWebAccessHasUnsavedChanges, setRepoWebAccessHasUnsavedChanges] =
        useState(false);
    const [confirmCloseRepoWebAccessModal, setConfirmCloseRepoWebAccessModal] =
        useState(false);
    const [showSelectTemplateModal, setShowSelectTemplateModal] =
        useState(false);
    const [selectedRepoForTemplate, setSelectedRepoForTemplate] =
        useState(null);
    const [currentTemplate, setCurrentTemplate] = useState(null);
    const [showReRunExtractionModal, setShowReRunExtractionModal] =
        useState(false);
    const [selectedRepoForReRun, setSelectedRepoForReRun] = useState(null);
    const [viewDefaultTemplateModal, setViewDefaultTemplateModal] =
        useState(null);
    const [toSetDefaultTemplate, setToSetDefaultTemplate] = useState(null);
    const [isOrganizationMember, setIsOrganizationMember] = useState(false);
    const [organizationId, setOrganizationId] = useState(null);
    // Org of any member (not just admins). WhatsApp is open to every user;
    // with no org (null) the backend scopes numbers to the connecting user.
    const [memberOrgId, setMemberOrgId] = useState(null);
    const [extractInfoItem, setExtractInfoItem] = useState(null);
    const [extractInfoMode, setExtractInfoMode] = useState(false);
    const [showTelegramForm, setShowTelegramForm] = useState(false);
    const [showTelegramDetails, setShowTelegramDetails] = useState(false);
    const [selectRepoForTelegram, setSelectRepoForTelegram] = useState(null);
    const [showWhatsAppPanel, setShowWhatsAppPanel] = useState(false);
    const [selectedRepoForWhatsApp, setSelectedRepoForWhatsApp] = useState(null);
    const [fetchedUrlList, setFetchedUrlList] = useState([]);
    const [configureRepoMode, setConfigureRepoMode] = useState(false);
    const [repoToConfigure, setRepoToConfigure] = useState(null);
    const [showDebugModal, setShowDebugModal] = useState(false);
    const [fileName, setFileName] = useState(null);
    // Tracks which repo's FilesListView instance opened the (shared) debug/view
    // modal, so that when multiple repos are expanded at once, only the repo
    // that actually owns the clicked file renders the modal / fetches its content.
    const [debugModalRepoId, setDebugModalRepoId] = useState(null);
    const [emailInterfaceModal, setEmailInterfaceModal] = useState(false);
    const [selectedRepoForEmail, setSelectedRepoForEmail] = useState(null);
    const [emailInterfaceList, setEmailInterfaceList] = useState([]);
    const [showVirtualRepoModal, setShowVirtualRepoModal] = useState(false);
    const [selectedRepoForVirtual, setSelectedRepoForVirtual] = useState(null);
    const [virtualRepoHasUnsavedChanges, setVirtualRepoHasUnsavedChanges] =
        useState(false);
    const [confirmCloseVirtualRepoModal, setConfirmCloseVirtualRepoModal] =
        useState(false);
    const [questionsModalOpen, setQuestionsModalOpen] = useState(false);
    const [selectedRepoId, setSelectedRepoId] = useState(null);

    const [virtualRepos, setVirtualRepos] = useState([]);
    const [sharedVirtualRepos, setSharedVirtualRepos] = useState([]);
    const BREAKPOINT_WIDTH = 1024;
    const location = useLocation();
    const path = location.pathname;

    const timeout = setTimeout(() => {
        setCloseDropdownSignal(false);
    }, 500);

    const toggleDropdownSignal = () => {
        clearTimeout(timeout);
        setCloseDropdownSignal(true);
        setTimeout(timeout);
    };

    const handleEnableTelegramInterface = (repo) => {
        setSelectRepoForTelegram(repo);

        if (repo.telegramEnabled) {
            setShowTelegramDetails(true);
        } else {
            setShowTelegramForm(true);
        }
    };

    const handleEnableEmailInterface = (repo) => {
        setSelectedRepoForEmail(repo);
        setEmailInterfaceModal(true);
    };

    const handleEnableWhatsAppInterface = (repo) => {
        setSelectedRepoForWhatsApp(repo);
        setShowWhatsAppPanel(true);
    };

    const handleScrollToRepo = (index) => {
        if (itemRefs.current[index]) {
            itemRefs.current[index].scrollIntoView({
                behavior: 'auto', // instant scrolling behavior
                block: 'start', // Scroll to start of the viewport
            });
        }
    };
    const isOrganizationMemberCheck = async () => {
        try {
            const url = getUrl(
                `http://${Config.NODE_SERVER_HOST}:${Config.NODE_SERVER_PORT}/organization/details`
            );
            const authToken = encodeURIComponent(user.token);

            const response = await axios.get(url, {
                headers: {
                    Authorization: authToken,
                },
            });

            const data = response.data;

            if (data.details.id) {
                setMemberOrgId(data.details.id);
            }

            if (
                data.details.id &&
                data.details.userRole ===
                    OrganizationAccessOptions.ORGANISATION_ADMIN
            ) {
                setIsOrganizationMember(true);
                setOrganizationId(data.details.id);
            }
        } catch (err) {
            // console.log(err);
        }
    };

    const updateOrganizationRepo = async (repo_id, org_id, user_id) => {
        const url = getUrl(
            `http://${Config.NODE_SERVER_HOST}:${Config.NODE_SERVER_PORT}/update-organization-repos`
        );

        try {
            const response = await fetch(url, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify({ repo_id, org_id, user_id }),
            });

            const data = await response.json();

            if (response.ok) {
                message.success('Enabled organization wide access');
            } else {
                message.error(data.message);
            }
        } catch (error) {
            message.error('Error while enabling organization wide access');
        }
    };

    useEffect(() => {
        isOrganizationMemberCheck();
    }, []);

    useEffect(() => {
        if (scrollTo && !isLoading) {
            handleScrollToRepo(scrollTo);
        }
    }, [scrollTo, isLoading]);

    const getRepoProductMappings = async () => {
        try {
            setIsLoading(true);
            setLoadingText(`Loading repositories...`);

            const user = JSON.parse(localStorage.getItem('current'));
            // Build document-level mapping index
            const nextProductRepoMappings = {};
            const nextRepoProductMappings = {};
            const nextRepoHasFileProductMappings = {};

            // Derive product -> repo mappings from repo_product_mapping via Node server.
            const allRepos = await fetchAllChatsReposRaw();
            const repoIds = [...allRepos.Normal, ...allRepos.Shared]
                .map((r) => r.repoid)
                .filter((id) => id !== null && id !== undefined);

            // Derive repo-level product mappings via a single bulk call to the
            // existing Node endpoint (now supports repo_ids as well).
            try {
                const bulkRepoMappingUrl = getUrl(
                    `http://${Config.NODE_SERVER_HOST}:${Config.NODE_SERVER_PORT}/getRepoProductsMapping`
                );

                const bulkResp = await axios.post(bulkRepoMappingUrl, {
                    repo_ids: repoIds,
                });

                const bulkData = bulkResp?.data || {};
                const bulkMappings = bulkData?.mappings || [];

                bulkMappings.forEach((m) => {
                    if (!m || !m.productCategory || !m.product) return;
                    const key = `${m.productCategory}-${m.product}`;
                    nextProductRepoMappings[key] = m.repoId;
                });
            } catch (e) {
                // Ignore and fall back to no repo-level mappings if bulk call fails
            }

            // Determine which repos have any FILE->product mappings (file_product_mapping)
            // using a single batched API call.
            try {
                const baseUrl = `http://${Config.FAST_API_HOST}:${Config.FAST_API_PORT}`;
                const url = getUrl(
                    `${baseUrl}/customer_chat_routes/repos-with-file-product-mappings`
                );
                const resp = await fetch(url, {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json',
                    },
                    body: JSON.stringify({ repo_ids: repoIds }),
                });
                if (resp.ok) {
                    const data = await resp.json();
                    const mappedRepoIds = data?.repoIds;
                    if (Array.isArray(mappedRepoIds)) {
                        mappedRepoIds.forEach((rid) => {
                            nextRepoHasFileProductMappings[rid] = true;
                        });
                    }
                }
            } catch (e) {
                // ignore
            }

            // Also mark repos that have repo-level mapping enabled (repo_product_mapping)
            try {
                const enabledUrl = getUrl(
                    `http://${Config.NODE_SERVER_HOST}:${Config.NODE_SERVER_PORT}/getEnabledRepoProductMappings`
                );

                const enabledResp = await axios.post(enabledUrl, {
                    repo_ids: repoIds,
                });

                if (enabledResp) {
                    const enabledData = enabledResp.data;
                    const enabledRepoIds = enabledData?.repoIds;
                    if (Array.isArray(enabledRepoIds)) {
                        enabledRepoIds.forEach((rid) => {
                            nextRepoProductMappings[rid] = true;
                        });
                    }
                }
            } catch (e) {
                // ignore
            }

            setProductRepoMappings(nextProductRepoMappings);
            setRepoProductMappings(nextRepoProductMappings);
            setRepoHasFileProductMappings(nextRepoHasFileProductMappings);

            setIsLoading(false);
            setLoadingText('');
        } catch (error) {
            setIsLoading(false);
            setLoadingText('');
            alert(
                'Error fetching product mapping for repository',
                error.message
            );
        }
    };

    const getAdminList = async () => {
        try {
            setIsLoading(true);
            setLoadingText(`Loading...`);

            const user = JSON.parse(localStorage.getItem('current'));
            const response = await axios.get(
                getUrl(
                    `http://${Config.NODE_SERVER_HOST}:${Config.NODE_SERVER_PORT}/AdminList`
                ),
                { responseType: 'text' }
            );

            const result = response.data;
            const isAdminCheck = result.includes(user.email);
            safeSetIsAdmin(isAdminCheck);
        } catch (error) {
            setIsLoading(false);
            setLoadingText('');
            const msg = error?.message;
            if (msg) {
                alert(AlertType.ERROR, msg);
            }
        }
    };

    const fetchAllChatsReposRaw = async () => {
        const dynamicUrl = getUrl(
            `http://${Config.NODE_SERVER_HOST}:${Config.NODE_SERVER_PORT}/getAllChatsRepos/${user.email}`
        );
        const response = await axios.get(dynamicUrl);
        return response.data;
    };

    const getAllReposData = async () => {
        try {
            setIsLoading(true);
            setLoadingText(`Loading Repositories ...`);
            setGlobalRepos([]);

            const data = await fetchAllChatsReposRaw();

            const allRepos = [...data.Normal, ...data.Shared];
            const emailInterfaces = [];
            allRepos.forEach((item) => {
                if (item.emailInterface) {
                    emailInterfaces.push(item.emailInterface.toLowerCase());
                }
            });
            setEmailInterfaceList(emailInterfaces);

            const globalRepos = data.Normal.filter(
                (item) => item.repotype === RepoType.GLOBAL
            );

            const virtualRepos = data.Normal.filter(
                (item) => item.repotype === RepoType.VIRTUAL
            );

            const sharedVirtualRepos = data.Shared.filter(
                (item) => item.repotype === RepoType.VIRTUAL
            );

            const normalMasterAgents = data.Normal.filter(
                (item) => item.repotype === RepoType.MASTER_AGENT
            );
            const sharedMasterAgents = data.Shared.filter(
                (item) => item.repotype === RepoType.MASTER_AGENT
            );
            const masterAgentRepos = [
                ...normalMasterAgents,
                ...sharedMasterAgents,
            ];

            const sharedReposFiltered = data.Shared.filter(
                (item) =>
                    item.repotype !== RepoType.MASTER_AGENT &&
                    item.repotype !== RepoType.VIRTUAL
            );

            const normalRepos = data.Normal.filter(
                (item) =>
                    item.repotype !== RepoType.GLOBAL &&
                    item.repotype !== RepoType.MASTER_AGENT &&
                    item.repotype !== RepoType.VIRTUAL
            );

            if (normalRepos.length > 1) {
                setGlobalRepos(globalRepos);
            }
            setMasterAgentRepos(masterAgentRepos);
            setRepoDetails(normalRepos);
            setSharedRepos(sharedReposFiltered);
            setVirtualRepos(virtualRepos);
            setSharedVirtualRepos(sharedVirtualRepos);

            setIsLoading(false);
            setLoadingText('');
        } catch (error) {
            setIsLoading(false);
            setLoadingText('');
            alert(error);
        }
    };

    const downloadSchemaFile = async (item) => {
        try {
            const response = await axios.get(
                getUrl(
                    `http://${Config.FAST_API_HOST}:${Config.FAST_API_PORT}/process_schema/${item.email}/${item.name}`
                ),
                {
                    responseType: 'blob',
                }
            );
            FileDownload(response.data, `${item.name}_schema.txt`);
        } catch (error) {
            console.error('Error downloading the file', error);
        }
    };

    const uploadSchemaFile = async (item, file) => {
        const formData = new FormData();
        formData.append('file', file);
        setIsLoading(true);
        setLoadingText(`Uploading Schema...`);
        try {
            const response = await axios.post(
                getUrl(
                    `http://${Config.FAST_API_HOST}:${Config.FAST_API_PORT}/upload_schema/${item.email}/${item.name}`
                ),
                formData,
                {
                    headers: {
                        'Content-Type': 'multipart/form-data',
                    },
                }
            );
            message.success('Schema uploaded successfully!', 3);
            // console.log('Upload successful', response.data);
        } catch (error) {
            console.error('Error uploading the file', error);
            message.error('Error uploading the file');
        } finally {
            setIsLoading(false);
            setLoadingText('');
        }
    };

    const handleUpdateSchema = async (item) => {
        try {
            const email = item.email;
            const reponame = item.name;
            const response = await axios.post(
                getUrl(
                    `http://${Config.FAST_API_HOST}:${Config.FAST_API_PORT}/update-schema_postgress`
                ),
                {
                    email,
                    reponame,
                }
            );
            alert(response.data.message);
        } catch (error) {
            if (
                error.response &&
                error.response.data &&
                error.response.data.detail
            ) {
                alert(error.response.data.detail);
            } else {
                alert('An unexpected error occurred');
            }
        }
    };

    const findIfExpanded = (repoId) => {
        return (
            allReposFilesData &&
            allReposFilesData.has(repoId) &&
            allReposFilesData.get(repoId).isExpanded
        );
    };

    useEffect(() => {
        const repoId =
            selectedRepoForReRun?.repoid || selectedRepoForTemplate?.repoid;
        if (repoId) {
            fetchCurrentTemplate(repoId);
        }
    }, [selectedRepoForReRun, selectedRepoForTemplate]);

    useEffect(() => {
        (async () => {
            await getAdminList();
            await getAllReposData();
            await getRepoProductMappings();
        })();
    }, []);

    const handleDebuggingFile = async (item) => {
        try {
            setIsLoading(true);
            setLoadingText(`Downloading Diagnostics File ...`);

            const email = item.email;
            const foldername = item.name;
            const mode = 'qna';
            const response = await axios.post(
                getUrl(
                    `http://${Config.NODE_SERVER_HOST}:${Config.NODE_SERVER_PORT}/debuggingFile`
                ),
                { email, foldername, mode },
                { responseType: 'text' }
            );

            if (response.data) {
                const csvContent = response.data;

                // Create a Blob containing the CSV data
                const blob = new Blob([csvContent], { type: 'text/csv' });

                // Create an anchor element and set its href attribute to a data URL
                const link = document.createElement('a');
                link.href = window.URL.createObjectURL(blob);

                // Specify the filename for the download
                link.download = 'Details.csv';

                // Append the anchor to the document body and trigger a click
                document.body.appendChild(link);
                link.click();

                // Remove the anchor from the document body
                document.body.removeChild(link);

                setIsLoading(false);
                setLoadingText('');
            } else {
                setIsLoading(false);
                setLoadingText('');

                alert(AlertType.ERROR, 'Error downloading CSV.');
                // console.error(
                //     'Error downloading CSV:',
                //     response.status,
                //     response.statusText
                // );
            }
        } catch (error) {
            setIsLoading(false);
            setLoadingText('');
            const msg = error?.message ? `Error: ${error.message}` : '';
            if (msg) {
                alert(AlertType.ERROR, msg);
            }
        }
    };

    // A cloud repo's stored token is a bare access token from the import (about an hour,
    // no refresh token), so every refresh first gets a fresh one from the provider the
    // repo was imported from and sends it along.
    const [cloudAuth, setCloudAuth] = useState(null); // { platform, oneDriveClientId }
    const googleTokenRequest = useRef(null);
    const requestGoogleDriveToken = useGoogleLogin({
        scope: 'https://www.googleapis.com/auth/drive.readonly',
        onSuccess: (tokenResponse) =>
            googleTokenRequest.current?.resolve(tokenResponse.access_token),
        onError: (errorResponse) =>
            googleTokenRequest.current?.reject(
                new Error(errorResponse?.error_description || 'Google sign-in failed')
            ),
    });

    const getGoogleDriveToken = () =>
        new Promise((resolve, reject) => {
            const timer = setTimeout(
                () => reject(new Error('Google sign-in was not completed')),
                GOOGLE_TOKEN_TIMEOUT_MS
            );
            googleTokenRequest.current = {
                resolve: (token) => {
                    clearTimeout(timer);
                    resolve(token);
                },
                reject: (err) => {
                    clearTimeout(timer);
                    reject(err);
                },
            };
            requestGoogleDriveToken();
        });

    // Runs when the confirm dialog opens, so the click on "confirm" can open a sign-in
    // popup straight away (an await before it would get the popup blocked).
    const prepareCloudRefresh = async (item) => {
        setCloudAuth(null);
        try {
            const [platformRes, configRes] = await Promise.all([
                axios.get(
                    getUrl(
                        `http://${Config.FAST_API_HOST}:${Config.FAST_API_PORT}/cloud_repo_platform`
                    ),
                    { params: { email: item.email, repo_name: item.name } }
                ),
                axios.get(
                    getUrl(
                        `http://${Config.FAST_API_HOST}:${Config.FAST_API_PORT}/getCloudConfig?keys=oneDriveClientId`
                    )
                ),
            ]);
            const auth = {
                platform: platformRes.data?.platform,
                oneDriveClientId: configRes.data?.oneDriveClientId || '',
            };
            if (auth.platform === Platforms.ONE_DRIVE) {
                await prepareOneDriveAuth(auth.oneDriveClientId);
            }
            setCloudAuth(auth);
        } catch (error) {
            setCloudAuth({ error: error?.response?.data?.detail || error.message });
        }
    };

    const updateCloud = useCallback(
        async (item, auth) => {
            if (!auth || auth.error || !auth.platform) {
                alert(
                    AlertType.ERROR,
                    auth?.error ||
                        'Could not find the cloud connection for this repository. Please try again.'
                );
                return;
            }

            let freshToken;
            try {
                freshToken =
                    auth.platform === Platforms.ONE_DRIVE
                        ? await getOneDriveAccessToken(auth.oneDriveClientId)
                        : await getGoogleDriveToken();
            } catch (error) {
                alert(
                    AlertType.ERROR,
                    `Sign-in to ${
                        auth.platform === Platforms.ONE_DRIVE ? 'OneDrive' : 'Google Drive'
                    } is needed to refresh this repository. ${error?.message || ''}`.trim()
                );
                return;
            }

            try {
                setIsLoading(true);
                setLoadingText(`Updating Repository Data ...`);
                await axios.post(
                    getUrl(
                        `http://${Config.FAST_API_HOST}:${Config.FAST_API_PORT}/update_repository`
                    ),
                    {
                        email: item.email,
                        repo_name: item.name,
                        token_file: freshToken,
                    }
                );
            } catch (error) {
                // The backend's reason is in `detail`.
                alert(
                    AlertType.ERROR,
                    error?.response?.data?.detail ||
                        error?.message ||
                        'Error updating repository data.'
                );
            } finally {
                setIsLoading(false);
                setLoadingText('');
            }
        },
        // eslint-disable-next-line react-hooks/exhaustive-deps
        [requestGoogleDriveToken]
    );

    // Fetch what will break/be-torn-down before showing the confirm dialog, so
    // the warning can name the exact Telegram bot/groups + email inboxes +
    // dashboards affected (across the repo and its virtual/extraction sub-repos).
    const fetchDeletionImpact = async (repoid) => {
        setDeleteImpact(null);
        setDeleteImpactLoading(true);
        try {
            const url = getUrl(
                `http://${Config.FAST_API_HOST}:${Config.FAST_API_PORT}/repo_deletion_impact?repoid=${repoid}`
            );
            const response = await axios.get(url, {
                headers: { Authorization: encodeURIComponent(user.token) },
            });
            setDeleteImpact(response.data);
        } catch (error) {
            // Non-fatal: the confirm dialog still shows the generic warning.
            console.error('Failed to fetch deletion impact:', error);
        } finally {
            setDeleteImpactLoading(false);
        }
    };

    const finalizeDelete = async () => {
        try {
            setDeleteMode(false);
            setDeleteImpact(null);
            setIsLoading(true);
            setLoadingText(`Deleting ${toDelete.name} ...`);

            const encodedToken = encodeURIComponent(user.token);
            const dynamicUrl = getUrl(
                `http://${Config.FAST_API_HOST}:${Config.FAST_API_PORT}/new_delete`
            );

            // Create a FormData object and append the repoid
            const formData = new FormData();
            formData.append('repoid', toDelete.repoid);

            // axios throws on non-2xx, so a failed delete lands in the catch
            // below (which surfaces the error) instead of silently continuing.
            await axios.post(dynamicUrl, formData, {
                headers: {
                    Authorization: encodedToken,
                },
            });
            console.log('Deletion successful');

            setIsLoading(false);
            setLoadingText('');
            if (
                workOnRepo === toDelete.repoid ||
                window.innerWidth < BREAKPOINT_WIDTH
            ) {
                if (mode === MODE.QNA) {
                    chatrepofunction(-1);
                } else {
                    chatrepofunction(null);
                }
            }

            setTimeout(async () => {
                await getAllReposData();
            }, 500);
        } catch (error) {
            setIsLoading(false);
            setLoadingText('');
            alert('Error: ', error.message);
        }
    };

    // Builds the delete-confirmation body. Always includes the base warning;
    // when the impact fetch has returned, appends the exact integrations that
    // will be affected for end-users (Telegram bots/groups, email inboxes),
    // the dashboards that will lose cards, and the sub-repos that go with it.
    const renderDeleteWarning = () => {
        const impact = deleteImpact;
        const telegram = impact?.telegram ?? [];
        const emails = impact?.emails ?? [];
        const whatsapp = impact?.whatsapp ?? [];
        const dashboards = impact?.dashboards ?? [];
        const subRepos = (impact?.repos_to_delete ?? []).filter(
            (r) => r.repoid !== toDelete.repoid
        );

        return (
            <div className='flex flex-col gap-3 max-w-md'>
                <div>
                    Are you sure you want to permanently delete{' '}
                    <span className='font-semibold'>'{toDelete.name}'</span>?
                    All data for this repository — chats, extraction data, and
                    associated files — will be removed.
                </div>

                {deleteImpactLoading && (
                    <div className='text-sm text-texts-secondary'>
                        Checking linked integrations…
                    </div>
                )}

                {subRepos.length > 0 && (
                    <div className='text-sm'>
                        <div className='font-semibold text-buttons-alert400'>
                            {subRepos.length} linked sub-repo(s) will also be
                            deleted:
                        </div>
                        <ul className='list-disc ml-5'>
                            {subRepos.map((r) => (
                                <li key={r.repoid}>
                                    {r.name}{' '}
                                    <span className='text-texts-secondary'>
                                        ({r.repotype})
                                    </span>
                                </li>
                            ))}
                        </ul>
                    </div>
                )}

                {telegram.length > 0 && (
                    <div className='text-sm'>
                        <div className='font-semibold text-buttons-alert400'>
                            Telegram will stop working for end-users:
                        </div>
                        <ul className='list-disc ml-5'>
                            {telegram.map((t) => (
                                <li key={`${t.repo_name}-${t.bot_name}`}>
                                    Bot <span className='font-semibold'>{t.bot_name}</span>
                                    {t.groups && t.groups.length > 0 && (
                                        <>
                                            {' '}in group(s):{' '}
                                            {t.groups.join(', ')}
                                        </>
                                    )}
                                </li>
                            ))}
                        </ul>
                        <div className='text-texts-secondary mt-1'>
                            The bot will be removed and made to leave its
                            group(s) automatically. You may still want to delete
                            the group(s) in Telegram manually.
                        </div>
                    </div>
                )}

                {emails.length > 0 && (
                    <div className='text-sm'>
                        <div className='font-semibold text-buttons-alert400'>
                            Email support will stop for:
                        </div>
                        <ul className='list-disc ml-5'>
                            {emails.map((e) => (
                                <li key={`${e.repo_name}-${e.email}`}>
                                    {e.email}
                                </li>
                            ))}
                        </ul>
                    </div>
                )}

                {whatsapp.length > 0 && (
                    <div className='text-sm'>
                        <div className='font-semibold text-buttons-alert400'>
                            WhatsApp will stop working for end-users:
                        </div>
                        <ul className='list-disc ml-5'>
                            {whatsapp.map((w, i) =>
                                w.kind === 'group' ? (
                                    <li key={`wa-g-${i}`}>
                                        Group{' '}
                                        <span className='font-semibold'>
                                            {w.group_name}
                                        </span>
                                    </li>
                                ) : (
                                    <li key={`wa-n-${i}`}>
                                        Number{' '}
                                        <span className='font-semibold'>
                                            {w.display_number}
                                        </span>{' '}
                                        ({w.mode}
                                        {w.role === 'fallback'
                                            ? ' — fallback repo'
                                            : ''}
                                        )
                                    </li>
                                )
                            )}
                        </ul>
                    </div>
                )}

                {dashboards.length > 0 && (
                    <div className='text-sm'>
                        <div className='font-semibold text-buttons-alert400'>
                            Dashboard card(s) will be removed:
                        </div>
                        <ul className='list-disc ml-5'>
                            {dashboards.map((d) => (
                                <li key={d.dashboard_name}>
                                    {d.dashboard_name} — {d.widget_count} card(s)
                                </li>
                            ))}
                        </ul>
                    </div>
                )}
            </div>
        );
    };

    const updateMap = (key, value) => {
        const deepCopyMap = new Map(
            JSON.parse(JSON.stringify(Array.from(allReposFilesData)))
        );
        deepCopyMap.set(key, value);
        setAllReposFilesData(deepCopyMap);
    };

    const updateMapSubData = (key, subKey, subValue) => {
        const data = allReposFilesData.get(key);
        if (data) {
            const copyData = { ...data };
            copyData[subKey] = subValue;

            updateMap(key, copyData);
        }
    };

    const getRepoFilesData = async (
        repoId,
        parentControlledLoading = true,
        markExpanded = true
    ) => {
        try {
            if (parentControlledLoading) {
                setIsLoading(true);
                setLoadingText("Loading repo's files data ...");
            }

            const dynamicUrl = getUrl(
                `http://${Config.NODE_SERVER_HOST}:${Config.NODE_SERVER_PORT}/new_alldocs/${repoId}`
            );

            const response = await axios.get(dynamicUrl);

            const repoData = {
                filesData: response.data,
                isExpanded: markExpanded
                    ? true
                    : !!allReposFilesData.get(repoId)?.isExpanded,
            };

            updateMap(repoId, repoData);

            if (parentControlledLoading) {
                setIsLoading(false);
                setLoadingText('');
            }
        } catch (error) {
            if (parentControlledLoading) {
                setIsLoading(false);
                setLoadingText('');
            }
            alert('Error: ', error.message);
        }
    };

    const handle_table_extraction = async (repoid) => {
        try {
            // Define the API endpoint with the repoid as a query parameter

            const apiUrl = getUrl(
                `http://${Config.FAST_API_HOST}:${
                    Config.FAST_API_PORT
                }/customer_chat_routes/create-csv?repoid=${encodeURIComponent(
                    repoid
                )}`
            );

            // Fetch the file from the API
            const response = await fetch(apiUrl);

            // Check if the response is successful
            if (!response.ok) {
                throw new Error(`Error: ${response.statusText}`);
            }

            // Get the response as a Blob
            const blob = await response.blob();

            // Create an Object URL from the Blob
            const fileUrl = URL.createObjectURL(blob);

            // Automatically trigger the file download
            const fileName =
                response.headers
                    .get('Content-Disposition')
                    ?.split('filename=')[1] || 'extracted_tables.csv';

            // Create a temporary link and trigger the download
            const link = document.createElement('a');
            link.href = fileUrl;
            link.download = fileName.replace(/"/g, ''); // Clean up the filename
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);

            // Revoke the Object URL to free memory
            URL.revokeObjectURL(fileUrl);
        } catch (error) {
            // Handle errors
            console.error('Failed to download the file:', error);
            alert('An error occurred while downloading the file.');
        }
    };

    const fetchCurrentTemplate = async (repoId) => {
        try {
            const response = await axios.get(
                getUrl(
                    `http://${Config.NODE_SERVER_HOST}:${Config.NODE_SERVER_PORT}/getCurrentTemplate/${repoId}`
                )
            );

            console.log('result', response.data);
            setCurrentTemplate(response.data);
        } catch (error) {
            console.error('Error fetching current template:', error);
            setCurrentTemplate(null);
        }
    };

    const getRepoIcon = (item) => {
        if (item.storage_type === RepoType.EXTRACTED_DB) return faTableColumns;
        if (item.storage_type === RepoType.AUTO_DB) return faTable;
        if (item.repotype === RepoType.TABULAR) return faTable;
        if (
            [RepoType.SQLLITE, RepoType.POSTGRESS, RepoType.MSSQL].includes(
                item.repotype
            )
        )
            return faDatabase;
        if (item.repotype === RepoType.GLOBAL) return faFolder;
        if (item.repotype === RepoType.MASTER_AGENT) return faUsers;
        if (item.storage_type === RepoType.EMAIL)
            return findIfExpanded(item.repoid) ? faEnvelopeOpen : faEnvelope;

        return findIfExpanded(item.repoid) ? faFolderOpen : faFolderClosed;
    };

    const fetchUrlInfo = async (repoId) => {
        try {
            const dynamicUrl = getUrl(
                `http://${Config.FAST_API_HOST}:${Config.FAST_API_PORT}/crawl/url_file_map?repo_id=${repoId}`
            );
            const response = await axios.get(dynamicUrl);

            const detailedMap = response.data;
            // Extract only the md_file_name → url pairs
            const urlMap = {};
            for (const [fileName, data] of Object.entries(detailedMap)) {
                urlMap[fileName] = data.url;
            }

            const urls = Object.values(urlMap);

            // Remove duplicates
            const uniqueUrls = [...new Set(urls)];
            // Store it (set state)
            setFetchedUrlList(uniqueUrls);
        } catch (error) {
            console.error('Error fetching URL info:', error);
        }
    };

    const isContentRepo = (repo) => {
        if (!repo) return false;
        return (
            repo.storage_type === RepoType.INTERNET ||
            repo.repotype === RepoType.CONTENT
        );
    };

    const sortRepositories = (repos, isRepoSortedAlphabetically) => {
        return isRepoSortedAlphabetically
            ? [...repos].sort((a, b) => a.name.localeCompare(b.name)) // alphabetical
            : [...repos].sort((a, b) => b.repoid - a.repoid); // latest first
    };

    const handleGenerateQuestions = async (repoId, repoName) => {
        try {
            const status = {
                message: `Started automated questions generation on ${repoName}`,
                percentageCompletion: 0,
                process: ProcessType.QUESTION_GENERATION,
                progress: TaskProgressType.STARTED,
                repoId: repoId,
                repoName: repoName,
                statusCode: 200,
                timeStamp: new Date(),
                userMail: user.email,
            };
            props.socket.emit('statusUpdate', status);
            const response = await axios.post(
                getUrl(
                    `http://${Config.FAST_API_HOST}:${Config.FAST_API_PORT}/aqg_routes/gen_ques`
                ),
                new URLSearchParams({ repoId }),
                {
                    headers: {
                        'Content-Type': 'application/x-www-form-urlencoded',
                    },
                }
            );

            const data = response.data;
            let status2 = {
                message: `Completed automated questions generation on ${repoName}`,
                percentageCompletion: 100,
                process: ProcessType.QUESTION_GENERATION,
                progress: TaskProgressType.COMPLETED,
                repoId: repoId,
                repoName: repoName,
                statusCode: 200,
                timeStamp: new Date(),
                userMail: user.email,
            };
            props.socket.emit('statusUpdate', status2);
        } catch (error) {
            console.error(
                'Error:',
                error.response?.data || error.message || error
            );
        }
    };

    const createKnowledgeGraph = async (email, foldername, repoId) => {
        try {
            const status = {
                message: `Started knowledge graph creation on ${foldername}`,
                percentageCompletion: 0,
                process: ProcessType.KNOWLEDGE_GRAPH_CREATION,
                progress: TaskProgressType.STARTED,
                repoId: repoId,
                repoName: foldername,
                statusCode: 200,
                timeStamp: new Date(),
                userMail: email,
            };
            props.socket.emit('statusUpdate', status);
            const response = await axios.post(
                getUrl(
                    `http://${Config.FAST_API_HOST}:${Config.FAST_API_PORT}/aqg_routes/create-graph`
                ),
                new URLSearchParams({ email, foldername }),
                {
                    headers: {
                        'Content-Type': 'application/x-www-form-urlencoded',
                    },
                }
            );

            const result = response.data;

            let status2 = {
                message: `Completed knowledge graph creation on ${foldername}`,
                percentageCompletion: 100,
                process: ProcessType.KNOWLEDGE_GRAPH_CREATION,
                progress: TaskProgressType.COMPLETED,
                repoId: repoId,
                repoName: foldername,
                statusCode: 200,
                timeStamp: new Date(),
                userMail: email,
            };
            props.socket.emit('statusUpdate', status2);
            // alert(result.message || 'Knowledge graph created successfully!');
            return result;
        } catch (error) {
            console.error(
                'Error creating knowledge graph:',
                error.response?.data || error.message || error
            );
            alert(AlertType.ERROR, `Error: ${error.message}`);
        }
    };

    const renderRepos = (
        repos,
        processingRepos,
        isRepoSortedAlphabetically
    ) => {
        const disableSubAction = processingRepos.length ? true : false;
        // Sort repositories
        const sortedRepos = sortRepositories(repos, isRepoSortedAlphabetically);
        const toReturn = sortedRepos.map((item, index) => {
            let shared = false;
            let admin = false;

            const isDbRepo = [
                RepoType.SQLLITE,
                RepoType.POSTGRESS,
                RepoType.MSSQL,
            ].includes(item.repotype);

            // Tabular repos expose a reduced action set: only Share, Configure,
            // Delete, Set Default Template, Enable Knowledge Graph and Enable
            // Organization Access. Extraction/question/batch actions are hidden.
            const isTabular = item.repotype === RepoType.TABULAR;

            if (item.shared_type) {
                shared = true;
                if (item.shared_type === UserAccessOptions.CHAT) {
                    admin = false;
                } else {
                    admin = true;
                }
            }

            let dropDownList = [];
            let botenableoption = [];
            let masterAgentDropDownList = [];

            if (!shared || (shared && admin)) {
                let userSpecificActionList = [];

                if (
                    isFeatureEnabled(
                        [Features.CHATS, ChatsFeatures.SHARE_REPOSITORY],
                        featureFlagsData
                    )
                ) {
                    userSpecificActionList.push({
                        label: 'Share Repository',
                        icon: faShare,
                        // iconColor: 'sky',
                        action: () => {
                            setToShare(item);
                            setViewSharingModal(true);
                        },
                        disabled: false,
                        type: 'success',
                    });

                    userSpecificActionList.push({
                        label: 'Configure Repository',
                        icon: faSliders,
                        action: () => {
                            setSelectedRepoForVirtual(item);
                            setVirtualRepoHasUnsavedChanges(false);
                            setShowVirtualRepoModal(true);
                        },
                        disabled: false,
                        type: 'success',
                    });
                }

                if (
                    isFeatureEnabled(
                        [Features.CHATS, ChatsFeatures.DELETE_REPOSITORY],
                        featureFlagsData
                    )
                ) {
                    userSpecificActionList.push({
                        label: 'Delete Repository',
                        icon: faTrash,
                        // iconColor: 'red',
                        action: () => {
                            setDeleteMode(true);
                            setToDelete(item);
                            fetchDeletionImpact(item.repoid);
                        },
                        disabled: false,
                        type: 'danger',
                    });
                }

                if (
                    isFeatureEnabled(
                        [Features.CHATS, ChatsFeatures.SET_DEFAULT_TEMPLATE],
                        featureFlagsData
                    )
                ) {
                    userSpecificActionList.push({
                        label: 'Set Default Template',
                        icon: faThumbTack,
                        // iconColor: 'red',
                        action: () => {
                            setToSetDefaultTemplate(item);
                            setViewDefaultTemplateModal(true);
                        },
                        disabled: false,
                        type: 'success',
                    });
                }

                if (
                    !isTabular &&
                    isFeatureEnabled(
                        [Features.CHATS, ChatsFeatures.EXTRACT_DATA_TO_DB],
                        featureFlagsData
                    )
                ) {
                    userSpecificActionList.push({
                        label: 'Extract Data to DB',
                        icon: faDatabase,
                        // iconColor: 'blue',
                        action: () => {
                            setSelectedRepoForTemplate(item);
                            setShowSelectTemplateModal(true);
                        },
                        disabled: disableSubAction,
                        type: 'success',
                    });
                }
                if (
                    isFeatureEnabled(
                        [Features.CHATS, ChatsFeatures.ENABLE_KNOWLEDGE_GRAPH],
                        featureFlagsData
                    )
                ) {
                    userSpecificActionList.push({
                        label: 'Enable Knowledge Graph',
                        icon: faProjectDiagram,
                        // iconColor: 'red',
                        action: () => {
                            createKnowledgeGraph(
                                user.email,
                                item.name,
                                item.repoid
                            );
                        },
                        disabled: item.knowledge_graph_exists,
                        type: 'success',
                    });
                }
                if (
                    !isTabular &&
                    isAdmin &&
                    isFeatureEnabled(
                        [Features.CHATS, ChatsFeatures.GENERATE_QUESTIONS],
                        featureFlagsData
                    )
                ) {
                    userSpecificActionList.push({
                        label: 'Generate Questions',
                        icon: faQuestionCircle,
                        disabled:
                            !item.knowledge_graph_exists &&
                            !item.is_aqg_completed,
                        hoverTextDisabled:
                            'Enable Knowledge Graph to generate Questions.',
                        action: () => {
                            handleGenerateQuestions(item.repoid, item.name);
                        },
                    });
                    userSpecificActionList.push({
                        label: 'Review/Edit Generated Questions',
                        icon: faPenToSquare,
                        disabled:
                            !item.knowledge_graph_exists &&
                            !item.is_aqg_completed,
                        hoverTextDisabled:
                            'Enable Knowledge Graph to Review/Edit Questions.',
                        action: () => {
                            setQuestionsModalOpen(true);
                            setSelectedRepoId({
                                repoId: item.repoid,
                                fileName: item.name,
                            });
                        },
                    });
                }

                if (
                    !isTabular &&
                    isFeatureEnabled(
                        [Features.CHATS, ChatsFeatures.RE_RUN_EXTRACTION],
                        featureFlagsData
                    )
                ) {
                    userSpecificActionList.push({
                        label: 'Re-run Extraction',
                        icon: faSync,
                        // iconColor: 'green',
                        action: () => {
                            fetchCurrentTemplate(item.repoid);
                            setSelectedRepoForReRun(item);
                            setShowReRunExtractionModal(true);
                        },
                        disabled: disableSubAction,
                        type: 'success',
                    });
                }

                const commonActionList = [];
                if (
                    isFeatureEnabled(
                        [Features.CHATS, ChatsFeatures.VIEW_REPOSITORY_STATUS],
                        featureFlagsData
                    )
                ) {
                    commonActionList.push({
                        label: 'View Repository Stats',
                        icon: faChartLine,
                        // iconColor: 'lightblue',
                        action: () => {
                            setToViewStatus(item);
                            setViewStatsModal(true);
                            setWorkOnRepo(item.repoid);
                            setViewRepodb(false);
                        },
                        disabled: false,
                        type: 'success',
                    });
                }

                if (item.storage_type === RepoType.CLOUD) {
                    const cloudTypeList = [];
                    if (
                        isFeatureEnabled(
                            [Features.CHATS, ChatsFeatures.UPDATE_REPOSITORY],
                            featureFlagsData
                        )
                    ) {
                        cloudTypeList.push({
                            label: 'Update Repository',
                            icon: faFileCirclePlus,

                            action: () => {
                                setUpdateCloudRepo(true);
                                setCloudInfo(item);
                                prepareCloudRefresh(item);
                            },
                            disabled: disableSubAction,
                            type: 'success',
                        });
                    }

                    userSpecificActionList = [
                        ...cloudTypeList,
                        ...userSpecificActionList,
                    ];
                } else if (
                    isContentRepo(item) &&
                    (!shared || (shared && admin))
                ) {
                    const contentActionList = [];
                    const canAddFile = isFeatureEnabled(
                        [Features.CHATS, ChatsFeatures.ADD_FILE],
                        featureFlagsData
                    );
                    const canAddUrl = isFeatureEnabled(
                        [Features.CHATS, ChatsFeatures.ADD_URL],
                        featureFlagsData
                    );

                    if (canAddFile || canAddUrl) {
                        contentActionList.push({
                            label: 'Add Content',
                            icon: faPlus,
                            action: () => {
                                setAddFileToRepo(item);
                                fetchUrlInfo(item.repoid);
                                setAddContentMode(true);
                            },
                            disabled: disableSubAction,
                            type: 'success',
                        });
                    }

                    userSpecificActionList = [
                        ...contentActionList,
                        ...userSpecificActionList,
                    ];
                }

                const secondaryFileList = [];

                if (
                    !isTabular &&
                    item.repotype !== RepoType.POSTGRESS &&
                    isFeatureEnabled(
                        [Features.CHATS, ChatsFeatures.EXTRACT_TABLES],
                        featureFlagsData
                    ) &&
                    !isDbRepo
                ) {
                    // secondaryFileList.push({
                    //     label: 'Extract Tables',
                    //     icon: faTable,
                    //     // iconColor: 'red',
                    //     action: () => {
                    //         handle_table_extraction(item.repoid);
                    //     },
                    //     disabled: disableSubAction,
                    //     type: 'success',
                    // });

                    secondaryFileList.push({
                        label: 'Auto Extract  Data',
                        icon: faFileExport,
                        // iconColor: 'red',
                        action: () => {
                            setExtractInfoItem(item);
                            setExtractInfoMode(true);
                        },
                        disabled: disableSubAction,
                        type: 'success',
                    });
                }

                userSpecificActionList = [
                    ...userSpecificActionList,
                    ...secondaryFileList,
                ];

                if (
                    item.repotype === RepoType.POSTGRESS ||
                    item.repotype === RepoType.MSSQL
                ) {
                    const postgresList = [];
                    if (
                        isFeatureEnabled(
                            [Features.CHATS, ChatsFeatures.UPDATE_SCHEMA],
                            featureFlagsData
                        )
                    ) {
                        postgresList.push({
                            label: 'Refresh schema from DB',
                            icon: faSync,
                            // iconColor: 'lightblue',
                            action: () => {
                                console.log('update the schema');
                                handleUpdateSchema(item);
                            },
                            disabled: false,
                            type: 'success',
                        });
                    }

                    userSpecificActionList = [
                        ...postgresList,
                        ...userSpecificActionList,
                    ];
                }

                if (!isTabular && isAdmin && onBatchOpen) {
                    userSpecificActionList.push({
                        label: 'Batch',
                        icon: faLayerGroup,
                        action: () => onBatchOpen(item, BatchType.QNA),
                        hoverText: 'Run QnA batch or eval on this repo',
                    });
                    userSpecificActionList.push({
                        label: 'Batch & Extract',
                        icon: faTable,
                        action: () => onBatchOpen(item, BatchType.EXTRACT),
                        hoverText: 'Run extraction batch or eval on this repo',
                    });
                }

                dropDownList = [...userSpecificActionList];
                if (item.repotype === RepoType.MASTER_AGENT) {
                    masterAgentDropDownList = [
                        ...masterAgentDropDownList,
                        {
                            label: 'Configure Repository',
                            icon: faSliders,
                            action: () => {
                                setSelectedRepoForVirtual(item);
                                setVirtualRepoHasUnsavedChanges(false);
                                setShowVirtualRepoModal(true);
                            },
                            disabled: false,
                            type: 'success',
                        },
                    ];
                }
            }

            const commonActionList = [];
            if (
                isFeatureEnabled(
                    [Features.CHATS, ChatsFeatures.VIEW_REPOSITORY_STATUS],
                    featureFlagsData
                )
            ) {
                commonActionList.push({
                    label: 'View Repository Stats',
                    icon: faChartLine,
                    // iconColor: 'lightblue',
                    action: () => {
                        setToViewStatus(item);
                        setViewStatsModal(true);
                        setWorkOnRepo(item.repoid);
                        setViewRepodb(false);
                    },
                    disabled: false,
                    type: 'success',
                });
            }

            dropDownList = [...dropDownList, ...botenableoption];
            masterAgentDropDownList = [
                ...masterAgentDropDownList,
                ...botenableoption,
            ];

            if (isDbRepo) {
                const commonActionListdb = [];
                if (
                    isFeatureEnabled(
                        [Features.CHATS, ChatsFeatures.VIEW_DATABASE_STATUS],
                        featureFlagsData
                    )
                ) {
                    commonActionListdb.push({
                        label: 'View Database Stats',
                        icon: faChartLine,
                        // iconColor: 'lightblue',
                        action: () => {
                            setToViewStatus(item);
                            setViewStatsModal(true);
                            setViewRepodb(true);
                        },
                        disabled: false,
                        type: 'success',
                    });
                }
                if (
                    isFeatureEnabled(
                        [Features.CHATS, ChatsFeatures.DOWNLOAD_SCHEMA],
                        featureFlagsData
                    )
                ) {
                    commonActionListdb.push({
                        label: 'Download schema',
                        icon: faDownload,
                        // iconColor: 'lightblue',
                        action: () => {
                            downloadSchemaFile(item);
                        },
                        disabled: false,
                        type: 'success',
                    });
                }
                if (
                    isFeatureEnabled(
                        [Features.CHATS, ChatsFeatures.UPLOAD_ANNOTATED_SCHEMA],
                        featureFlagsData
                    )
                ) {
                    commonActionListdb.push({
                        label: 'Upload Annotated schema',
                        icon: faUpload,
                        // iconColor: 'green',
                        action: () => {
                            const fileInput = document.createElement('input');
                            fileInput.type = 'file';
                            fileInput.accept = '.txt';
                            fileInput.onchange = async (event) => {
                                const file = event.target.files[0];
                                if (file) {
                                    uploadSchemaFile(item, file);
                                }
                            };
                            fileInput.click();
                        },
                        disabled: false,
                        type: 'success',
                    });
                }

                dropDownList = [...dropDownList, ...commonActionListdb];
            }

            if (
                item.repotype === RepoType.CONTENT ||
                item.storage_type === RepoType.EMAIL
            ) {
                dropDownList = [...dropDownList, ...commonActionList];
            }
            if (
                isAdmin &&
                (item.repotype === RepoType.CONTENT ||
                    item.storage_type === RepoType.EMAIL ||
                    item.storage_type === RepoType.CLOUD)
            ) {
                const devModeActionList = [];
                if (
                    isFeatureEnabled(
                        [
                            Features.CHATS,
                            ChatsFeatures.DOWNLOAD_DIAGNOSTIC_DATA,
                        ],
                        featureFlagsData
                    )
                ) {
                    devModeActionList.push({
                        label: 'Download Diagnostic Data',
                        icon: faDownload,
                        // iconColor: 'lightblue',
                        action: async () => {
                            await handleDebuggingFile(item);
                        },
                        disabled: disableSubAction,
                        type: 'success',
                    });
                }

                dropDownList = [...dropDownList, ...devModeActionList];
            }
            if (isOrganizationMember) {
                const orgActionList = [];
                if (
                    isFeatureEnabled(
                        [
                            Features.CHATS,
                            ChatsFeatures.ENABLE_ORGANIZATION_ACCESS,
                        ],
                        featureFlagsData
                    )
                ) {
                    orgActionList.push({
                        label: 'Enable Organization Access',
                        icon: faBuildingCircleCheck,
                        // iconColor: 'sky',
                        action: () => {
                            updateOrganizationRepo(
                                item.repoid,
                                organizationId,
                                user.email
                            );
                        },
                        type: 'success',
                    });
                }

                dropDownList = [...dropDownList, ...orgActionList];
                masterAgentDropDownList = [
                    ...masterAgentDropDownList,
                    ...orgActionList,
                ];
            }

            const isExpanded = findIfExpanded(item.repoid);

            // Checking if any operation is going on this repo.
            const isProcessingOnRepo = processingRepos.find(
                (task) => task.repoId === item.repoid
            );

            return (
                <div
                    className='w-full text-texts-secondary300'
                    key={index}
                    ref={(el) => (itemRefs.current[item.repoid] = el)}
                >
                    <button
                        className={`w-full flex items-center justify-between px-3 py-0.5 border border-transparent hover:bg-backgrounds-primary100 hover:border hover:border-backgrounds-primary200 ${
                            workOnRepo === item.repoid
                                ? 'bg-backgrounds-primary100 border-backgrounds-primary300 text-texts-tertiary hover:border-backgrounds-primary200 shadow-inner'
                                : isExpanded
                                  ? 'bg-backgrounds-secondaryChat border-backgrounds-border shadow-inner'
                                  : ''
                        } ${
                            isExpanded ? 'rounded-t-xl mt-2' : 'rounded-xl my-2'
                        }`}
                        onClick={(event) => {
                            if (transactionMode) {
                                setTransactionMode(!transactionMode);
                            }

                            setFileToChat('');
                            if (
                                workOnRepo !== item.repoid &&
                                chatting_with_id !== item.repoid
                            ) {
                                setWorkOnRepo(item.repoid);
                                chatrepofunction(item);
                                set_fine_tuned(false);
                                set_chat_selected(true);
                                set_chatting_with_id(item.repoid);
                                if (window.innerWidth < BREAKPOINT_WIDTH) {
                                    props.closeSidebar(); // Call the closeSidebar function passed from navbar.jsx
                                    setWorkOnRepo(item.repoid);
                                    if (path === '/chats')
                                        togglePdfVisibility('reset');
                                }
                            }
                            setScrollTo(item.repoid);
                            event.stopPropagation();
                        }}
                    >
                        <div className='flex items-center justify-center truncate max-w-prose relative'>
                            <FontAwesomeIcon
                                title={
                                    isProcessingOnRepo
                                        ? 'Repository under process, check notification panel for details'
                                        : ''
                                }
                                icon={getRepoIcon(item)}
                                className={`mr-2 drop-shadow-sm ${
                                    isProcessingOnRepo
                                        ? 'text-icons-success animate-pulse'
                                        : shared
                                          ? 'text-icons-info'
                                          : workOnRepo === item.repoid
                                            ? 'text-backgrounds-primary300'
                                            : 'text-icons-primary'
                                }`}
                            />
                            {shared && (
                                <FontAwesomeIcon
                                    icon={faShare}
                                    fontSize={8}
                                    className='absolute left-1 bottom-1.5 drop-shadow-sm text-icons-secondary'
                                />
                            )}
                            {item.repotype === RepoType.GLOBAL && (
                                <FontAwesomeIcon
                                    icon={faG}
                                    fontSize={8}
                                    className='absolute left-1 drop-shadow-sm text-icons-secondary'
                                    style={{ bottom: '7px !important' }}
                                />
                            )}
                            <div
                                className={`truncate text-base ${
                                    workOnRepo === item.repoid &&
                                    'text-backgrounds-primary300'
                                }`}
                                title={item.name}
                            >
                                {item.name}
                            </div>
                            {item.telegramEnabled && (
                                <FontAwesomeIcon
                                    icon={faTelegram}
                                    className={`text-icons-primary ml-2 drop-shadow-sm}`}
                                    title='Telegram feature enabled on this repository'
                                    onClick={(e) => {
                                        e.stopPropagation();
                                        setSelectRepoForTelegram(item);
                                        setShowTelegramDetails(true);
                                    }}
                                />
                            )}
                            {item.whatsappEnabled && (
                                <FontAwesomeIcon
                                    icon={faWhatsapp}
                                    className={`text-icons-primary ml-2 drop-shadow-sm}`}
                                    title='WhatsApp feature enabled on this repository'
                                    onClick={(e) => {
                                        e.stopPropagation();
                                        handleEnableWhatsAppInterface(item);
                                    }}
                                />
                            )}
                            {item.emailInterface && (
                                <FontAwesomeIcon
                                    icon={faEnvelope}
                                    className={`text-icons-primary ml-2 drop-shadow-sm}`}
                                    title='Email interface enabled on this repository'
                                    onClick={(e) => {
                                        e.stopPropagation();
                                        setSelectedRepoForEmail(item);
                                        setEmailInterfaceModal(true);
                                    }}
                                />
                            )}
                        </div>
                        <div className='flex items-center justify-center'>
                            {(item.repotype === RepoType.CONTENT ||
                                item.storage_type === RepoType.INTERNET ||
                                item.storage_type === RepoType.CLOUD) && (
                                <Button
                                    className='ml-2 text-icons-primary'
                                    onClick={(event) => {
                                        if (!isExpanded) {
                                            getRepoFilesData(item.repoid);
                                        } else {
                                            updateMapSubData(
                                                item.repoid,
                                                'isExpanded',
                                                false
                                            );
                                        }
                                        setIsDropdownOpen(!isDropdownOpen);
                                        setScrollTo(item.repoid);
                                        event.stopPropagation();
                                    }}
                                    hoverText={
                                        isExpanded
                                            ? 'Collapse and hide list of files in repository'
                                            : 'Expand and show list of files in repository'
                                    }
                                    icon={isExpanded ? faCaretUp : faCaretDown}
                                    type={'warning'}
                                />
                            )}

                            {item.repotype === RepoType.GLOBAL ? (
                                <Dropdown
                                    dropDownList={[
                                        {
                                            label: 'Configure Repository',
                                            icon: faSliders,
                                            action: () => {
                                                setSelectedRepoForVirtual(item);
                                                setVirtualRepoHasUnsavedChanges(
                                                    false
                                                );
                                                setShowVirtualRepoModal(true);
                                            },
                                            disabled: false,
                                            type: 'success',
                                        },
                                        {
                                            label: 'Product Mapping',
                                            icon: faArrowsToDot,
                                            action: () => {
                                                setViewProductMappingModal(true);
                                            },
                                            disabled: false,
                                            type: 'success',
                                        },
                                    ]}
                                    icon={
                                        <FontAwesomeIcon icon={faEllipsisV} />
                                    }
                                    showButtonText={false}
                                    buttonText={null}
                                    buttonHoverText={'More Repository Actions'}
                                    additionalButtonAction={() => {
                                        setCloseDropdownSignal(false);
                                    }}
                                    titleText={'Repository Actions'}
                                    buttonClassName={`px-3.5 py-2 ml-2`}
                                    backgroundColor={'white'}
                                    textColor={'green'}
                                    disabled={isProcessingOnRepo}
                                    placement={'bottom'}
                                    closeSignal={closeDropdownSignal}
                                    listTitleText={'Repository Actions'}
                                />
                            ) : (
                                !(item.repotype === RepoType.MASTER_AGENT) && (
                                    <Dropdown
                                        dropDownList={dropDownList}
                                        icon={
                                            <FontAwesomeIcon
                                                icon={faEllipsisV}
                                            />
                                        }
                                        showButtonText={false}
                                        buttonText={null}
                                        buttonHoverText={
                                            isProcessingOnRepo
                                                ? 'Disabled as a task is being performed on this repo.'
                                                : 'More Repository Actions'
                                        }
                                        additionalButtonAction={() => {
                                            setCloseDropdownSignal(false);
                                        }}
                                        titleText={'Repository Actions'}
                                        buttonClassName={`px-3.5 py-2 ml-2`}
                                        backgroundColor={'white'}
                                        textColor={'green'}
                                        disabled={isProcessingOnRepo}
                                        placement={'bottom'}
                                        closeSignal={closeDropdownSignal}
                                        listTitleText={'Repository Actions'}
                                    />
                                )
                            )}

                            {item.repotype === RepoType.MASTER_AGENT && (
                                <Dropdown
                                    dropDownList={masterAgentDropDownList}
                                    icon={
                                        <FontAwesomeIcon icon={faEllipsisV} />
                                    }
                                    showButtonText={false}
                                    buttonText={null}
                                    buttonHoverText={
                                        isProcessingOnRepo
                                            ? 'Disabled as a task is being performed on this repo.'
                                            : 'More Repository Actions'
                                    }
                                    additionalButtonAction={() => {
                                        setCloseDropdownSignal(false);
                                    }}
                                    titleText={'Repository Actions'}
                                    buttonClassName={`px-3.5 py-2 ml-2`}
                                    backgroundColor={'white'}
                                    textColor={'green'}
                                    disabled={isProcessingOnRepo}
                                    placement={'bottom'}
                                    closeSignal={closeDropdownSignal}
                                    listTitleText={'Repository Actions'}
                                />
                            )}
                        </div>
                    </button>
                    {/* {workOnRepo === item.repoid && showIcons && (
                        <div className='flex items-center justify-around m-2 bg-backgrounds-slate p-2 rounded-xl'>

                            <button
                                className='hover:scale-125'
                                onClick={() => {
                                    chatrepofunction(item);
                                    set_fine_tuned(true);
                                    set_chat_selected(false);
                                    set_chatting_with_id(item.repoid);
                                }}
                                hoverText='Chat with fine tune model of repository'
                            >
                                <FontAwesomeIcon
                                    icon={faComment}
                                    color={
                                        chatting_with_id === item.repoid &&
                                        props.fine_tune
                                            ? 'lightblue'
                                            : `inherit`
                                    }
                                />
                            </button>
                        </div>
                    )} */}
                    <FilesListView
                        repo={item}
                        allReposFilesData={allReposFilesData}
                        setWorkOnRepo={setWorkOnRepo}
                        repoId={item.repoid}
                        email={item.email}
                        chatrepofunction={chatrepofunction}
                        folderName={item.name}
                        workOnRepo={workOnRepo}
                        mode={mode}
                        setFileToChat={setFileToChat}
                        fileToChat={fileToChat}
                        isAdmin={isAdmin}
                        closeSidebar={props.closeSidebar}
                        togglePdfVisibility={togglePdfVisibility}
                        getRepoFilesData={getRepoFilesData}
                        setIsLoading={setIsLoading}
                        isRepoSortedAlphabetically={
                            props.isRepoSortedAlphabetically
                        }
                        fileName={fileName}
                        setFileName={setFileName}
                        showDebugModal={showDebugModal}
                        setShowDebugModal={setShowDebugModal}
                        debugModalRepoId={debugModalRepoId}
                        setDebugModalRepoId={setDebugModalRepoId}
                        socket={props.socket}
                        processingRepos={processingRepos}
                        setQuestionsModalOpen={setQuestionsModalOpen}
                        currentUserHasAdminRightsOnRepo={admin}
                        isSharedToCurrentUser={shared}
                    />
                </div>
            );
        });
        return toReturn;
    };

    const getVirtualRepoParentId = (repo) => {
        if (!repo) return null;
        return repo.parent_repo_id ?? repo.parent_repo ?? null;
    };

    const getVirtualReposForBaseRepo = (baseRepoId) => {
        if (!baseRepoId) return [];
        return (virtualRepos || []).filter(
            (vr) => String(getVirtualRepoParentId(vr)) === String(baseRepoId)
        );
    };

    const processingRepos = props.processingRepos ? props.processingRepos : [];

    const productMappingEligibleRepos = useMemo(() => {
        const isDbRepoType = (item) =>
            [RepoType.SQLLITE, RepoType.POSTGRESS, RepoType.MSSQL].includes(
                item.repotype
            );

        const isEligibleForProductMapping = (item) =>
            !item.parent_repo &&
            item.repotype !== RepoType.GLOBAL &&
            !isDbRepoType(item);

        const eligibleNormalRepos = repoDetails.filter(
            isEligibleForProductMapping
        );

        // Mirrors the admin-access gating used elsewhere for shared repos
        // (shared_type other than CHAT grants edit-level access).
        const eligibleSharedRepos = sharedRepos.filter(
            (item) =>
                isEligibleForProductMapping(item) &&
                item.shared_type &&
                item.shared_type !== UserAccessOptions.CHAT
        );

        return [...eligibleNormalRepos, ...eligibleSharedRepos];
    }, [repoDetails, sharedRepos]);

    const matchesRepoSearch = (repo) =>
        !repoSearch.trim() ||
        (repo.name || '').toLowerCase().includes(repoSearch.trim().toLowerCase());

    const filteredGlobalRepos = globalRepos.filter(matchesRepoSearch);
    const filteredMasterAgentRepos = masterAgentRepos.filter(matchesRepoSearch);
    const filteredNormalRepos = repoDetails.filter(matchesRepoSearch);
    const filteredSharedRepos = sharedRepos.filter(matchesRepoSearch);
    const noRepoSearchResults =
        !!repoSearch.trim() &&
        filteredGlobalRepos.length === 0 &&
        filteredMasterAgentRepos.length === 0 &&
        filteredNormalRepos.length === 0 &&
        filteredSharedRepos.length === 0;

    const renderGlobalRepos = renderRepos(
        filteredGlobalRepos,
        processingRepos,
        props.isRepoSortedAlphabetically
    );
    const renderMasterAgentRepos = renderRepos(
        filteredMasterAgentRepos,
        processingRepos,
        props.isRepoSortedAlphabetically
    );
    const renderNormalRepos = renderRepos(
        filteredNormalRepos,
        processingRepos,
        props.isRepoSortedAlphabetically
    );
    const renderSharedRepos = renderRepos(
        filteredSharedRepos,
        processingRepos,
        props.isRepoSortedAlphabetically
    );

    const truncateText = (text, maxLength) => {
        return text.length > maxLength
            ? `${text.substring(0, maxLength)}...`
            : text;
    };
    const sortOptions = [
        {
            label: 'Sort Alphabetically',
            icon: faSortAlphaDown,
            type: 'success',
            action: () => props.setIsRepoSortedAlphabetically(true),
        },
        {
            label: 'Sort by Newest First',
            icon: faSortAmountDown,
            type: 'success',
            action: () => props.setIsRepoSortedAlphabetically(false),
        },
    ];

    return (
        <div
            className={`z-0 h-full w-full transition-all duration-700 ease-in-out bg-transparent p-1 m-0 rounded-xl`}
        >
            <ReflexContainer orientation='horizontal'>
                <ReflexElement
                    className='header border-b-2 border-b-backgrounds-white'
                    style={{
                        minHeight: '8rem',
                        height: '8rem',
                        maxHeight: '8rem',
                    }}
                >
                    <div className='pane-content w-full h-full pb-2 px-1'>
                        <div className='w-full h-full flex flex-col justify-between items-center'>
                            {isFeatureEnabled(
                                [Features.OTHERS, OtherFeatures.LOGO],
                                featureFlagsData
                            ) && <Brand />}

                            <div className='w-full flex items-center justify-between text-texts-secondary300'>
                                <div className='w-full flex items-center truncate'>
                                    <FontAwesomeIcon
                                        icon={faFolder}
                                        className='mr-2 drop-shadow-sm text-icons-primary'
                                    />
                                    <div className='font-semibold truncate text-base text-texts-secondary300'>
                                        Repositories
                                    </div>
                                </div>
                                <div className='flex items-center justify-center'>
                                    {isFeatureEnabled(
                                        [
                                            Features.CHATS,
                                            ChatsFeatures.ADD_NEW_REPOSITORY,
                                        ],
                                        featureFlagsData
                                    ) && (
                                        <Button
                                            icon={faFolderPlus}
                                            className={
                                                'mr-2 w-9 h-9 text-icons-primary'
                                            }
                                            onClick={() => {
                                                setAddNewMode(true);
                                            }}
                                            disabled={processingRepos.length}
                                            hoverText={
                                                processingRepos.length
                                                    ? 'Create new repo is disabled as a heavy task is under progress'
                                                    : 'Add new repository'
                                            }
                                            type={'success'}
                                        />
                                    )}
                                    <Dropdown
                                        dropDownList={sortOptions}
                                        icon={<FontAwesomeIcon icon={faSort} />}
                                        showButtonText={false}
                                        buttonText={null}
                                        listTitleText={'Sort folders and files'}
                                        buttonHoverText={
                                            'Sort repositories and files.'
                                        }
                                        additionalButtonAction={() => {
                                            setCloseDropdownSignal(false);
                                        }}
                                        titleText={'Sort Repositories'}
                                        buttonClassName={'mr-2 w-9 h-9'}
                                        backgroundColor={'white'}
                                        textColor={'green'}
                                        placement={'right'}
                                        closeSignal={closeDropdownSignal}
                                    />

                                    <Button
                                        icon={faCaretLeft}
                                        className={'w-9 h-9 text-icons-primary'}
                                        onClick={() => {
                                            if (
                                                window.innerWidth >
                                                BREAKPOINT_WIDTH
                                            ) {
                                                props.setIsRepoViewExpanded(
                                                    false
                                                );
                                            } else {
                                                props.closeSidebar();
                                            }
                                        }}
                                        hoverText={
                                            'Collapse and hide repositories view'
                                        }
                                        type={'warning'}
                                    />
                                </div>
                            </div>
                        </div>
                    </div>
                </ReflexElement>

                <ReflexElement flex={1}>
                    <div className='w-full h-full pane-content p-1 flex flex-col'>
                        <div className='shrink-0 pb-1'>
                            <SearchFilterInput
                                value={repoSearch}
                                onChange={(e) => setRepoSearch(e.target.value)}
                                placeholder='Search repositories'
                                className='w-full'
                            />
                        </div>
                        {isLoading && (
                            <div className='w-full flex-1 flex justify-center items-center break-all'>
                                <LoadingView
                                    loadingText={loadingText}
                                    inLine={false}
                                />
                            </div>
                        )}
                        {!isLoading && (
                            <div
                                className='w-full flex-1 min-h-0 overflow-auto'
                                onScroll={() => {
                                    toggleDropdownSignal();
                                }}
                            >
                                <div
                                    className={
                                        filteredMasterAgentRepos.length
                                            ? 'border-b border-b-white'
                                            : null
                                    }
                                >
                                    {renderMasterAgentRepos}
                                </div>
                                <div
                                    className={
                                        filteredGlobalRepos.length
                                            ? 'border-b border-b-white'
                                            : null
                                    }
                                >
                                    {renderGlobalRepos}
                                </div>

                                <div>{renderNormalRepos}</div>
                                <div
                                    className={
                                        filteredSharedRepos.length
                                            ? 'border-b border-b-white'
                                            : null
                                    }
                                >
                                    {renderSharedRepos}
                                </div>
                                {noRepoSearchResults && (
                                    <div className='w-full flex flex-col items-center justify-center text-center text-texts-secondary300 font-semibold p-6'>
                                        No repositories match your search
                                    </div>
                                )}
                            </div>
                        )}
                    </div>
                </ReflexElement>

                <ReflexElement
                    className='footer border-t-2 border-t-backgrounds-white'
                    style={{
                        minHeight: '7rem',
                        height: '7rem',
                        maxHeight: '7rem',
                    }}
                >
                    <div className='pane-content w-full h-full'>
                        <UserDetailAndAction planName={planName} />
                    </div>
                </ReflexElement>
            </ReflexContainer>

            {addNewMode && (
                <Modal
                    title={'Add New Repository'}
                    titleIcon={faFolderPlus}
                    iconColor={'lightblue'}
                    onClose={() => setAddNewMode(false)}
                >
                    <AddNewRepo
                        setAddNewMode={setAddNewMode}
                        getAllReposData={getAllReposData}
                        socket={props.socket}
                        setViewNotifications={props.setViewNotifications}
                        closeSidebar={props.closeSidebar}
                        isAdmin={isAdmin}
                        isOrganizationMember={isOrganizationMember}
                        organizationId={organizationId}
                    />
                </Modal>
            )}

            {addContentMode && addFileToRepo && (
                <Modal
                    title={'Add Content'}
                    titleIcon={faPlus}
                    iconColor={'lightblue'}
                    bodyClassName='w-full bg-backgrounds-slate border rounded-xl overflow-hidden'
                    onClose={() => {
                        setAddContentMode(false);
                    }}
                >
                    <AddContentToRepo
                        repo={addFileToRepo}
                        isAdmin={isAdmin}
                        getAllReposData={getAllReposData}
                        getRepoFilesData={getRepoFilesData}
                        socket={props.socket}
                        fetchedUrlList={fetchedUrlList}
                        setViewNotifications={props.setViewNotifications}
                        closeSidebar={props.closeSidebar}
                        onClose={setAddContentMode}
                        onUrlsAdded={() => {
                            props.setUrlsJustAdded?.(true);
                            setWorkOnRepo(addFileToRepo.repoid);
                        }}
                    />
                </Modal>
            )}

            {extractInfoMode && (
                <Modal
                    title={'Auto Extract Data'}
                    titleIcon={faFileExport}
                    iconColor={'lightblue'}
                    onClose={() => {
                        setExtractInfoMode(false);
                    }}
                >
                    <ExtractSupportInfo
                        extractInfoItem={extractInfoItem}
                        socket={props.socket}
                        setExtractInfoMode={setExtractInfoMode}
                        getAllReposData={getAllReposData}
                    ></ExtractSupportInfo>
                </Modal>
            )}

            {updateCloudRepo && (
                <ConfirmModal
                    modalText={`Do you want to update your Cloud Repository '${cloudInfo.name}'`}
                    onConfirm={() => {
                        updateCloud(cloudInfo, cloudAuth);

                        setUpdateCloudRepo(false);
                    }}
                    onCancel={() => {
                        setUpdateCloudRepo(false);
                    }}
                />
            )}

            {viewSharingModal && (
                <Modal
                    title={`Share '${truncateText(toShare.name, 20)}'`}
                    titleIcon={faShare}
                    iconColor={'sky'}
                    onClose={() => {
                        setViewSharingModal(false);
                    }}
                >
                    <ShareRepository
                        user={user}
                        repositoryData={toShare}
                        setViewSharingModal={setViewSharingModal}
                    />
                </Modal>
            )}

            {configureRepoMode && (
                <Modal
                    title={`Configure '${truncateText(repoToConfigure.name, 20)}'`}
                    titleIcon={faSliders}
                    iconColor={'sky'}
                    bodyClassName='w-full bg-backgrounds-slate border rounded-xl overflow-hidden'
                    onClose={() => {
                        setConfigureRepoMode(false);
                    }}
                >
                    <ConfigureRepo repoToConfigure={repoToConfigure} />
                </Modal>
            )}

            {viewDefaultTemplateModal && (
                <Modal
                    title={`Set default template for '${truncateText(
                        toSetDefaultTemplate.name,
                        20
                    )}'`}
                    titleIcon={faThumbTack}
                    iconColor={'sky'}
                    onClose={() => {
                        setViewDefaultTemplateModal(false);
                    }}
                >
                    <TemplateComponent
                        user={user}
                        repo={toSetDefaultTemplate}
                    ></TemplateComponent>
                </Modal>
            )}

            {viewStatsModal && (
                <Modal
                    title={`${
                        toViewStats.shared_type
                            ? `${toViewStats.name} Stats (${toViewStats.email})`
                            : `${toViewStats.name} Stats`
                    }`}
                    titleIcon={faChartLine}
                    iconColor={'lightblue'}
                    bodyClassName='w-full bg-backgrounds-slate border rounded-xl overflow-hidden'
                    onClose={() => {
                        setViewStatsModal(false);
                    }}
                >
                    {viewRepodb ? (
                        <RepoStatsDB
                            repoName={toViewStats.name}
                            email={toViewStats.email}
                        />
                    ) : (
                        <RepositoryStats
                            repository={toViewStats}
                            filesListData={allReposFilesData.get(
                                toViewStats.repoid
                            )}
                            mode={Mode.CHAT}
                            setFileName={setFileName}
                            setShowDebugModal={setShowDebugModal}
                        />
                    )}
                </Modal>
            )}

            {showVirtualRepoModal && selectedRepoForVirtual && (
                <Modal
                    title={`Configure Repository '${truncateText(
                        selectedRepoForVirtual.name,
                        20
                    )}'`}
                    titleIcon={faFolder}
                    iconColor={'lightblue'}
                    bodyClassName='w-full bg-backgrounds-slate border rounded-xl overflow-auto'
                    onClose={() => {
                        if (virtualRepoHasUnsavedChanges) {
                            setConfirmCloseVirtualRepoModal(true);
                        } else {
                            setShowVirtualRepoModal(false);
                            setSelectedRepoForVirtual(null);
                        }
                    }}
                >
                    <VirtualRepositoryModal
                        repo={selectedRepoForVirtual}
                        setHasUnsavedChanges={setVirtualRepoHasUnsavedChanges}
                        onEnableTelegramInterface={
                            handleEnableTelegramInterface
                        }
                        onEnableEmailInterface={handleEnableEmailInterface}
                        onEnableWhatsAppInterface={handleEnableWhatsAppInterface}
                        fetchAllChatsReposRaw={fetchAllChatsReposRaw}
                        onOpenRepoWebAccessSettings={(repoItem) => {
                            setToRepoWebAccess(repoItem);
                            setViewRepoWebAccessModal(true);
                        }}
                        refreshRef={virtualRepoRefreshRef}
                    />
                </Modal>
            )}

            {confirmCloseVirtualRepoModal && (
                <ConfirmModal
                    modalText={
                        "You have unsaved changes in 'Configure Repository'. Are you sure you want to discard them and close?"
                    }
                    onConfirm={() => {
                        setConfirmCloseVirtualRepoModal(false);
                        setShowVirtualRepoModal(false);
                        setSelectedRepoForVirtual(null);
                        setVirtualRepoHasUnsavedChanges(false);
                    }}
                    onCancel={() => {
                        setConfirmCloseVirtualRepoModal(false);
                    }}
                />
            )}

            {viewProductMappingModal && (
                <Modal
                    title={'Product Mapping'}
                    titleIcon={faArrowsToDot}
                    iconColor={'sky'}
                    onClose={() => {
                        if (productMappingHasUnsavedChanges) {
                            setConfirmCloseProductMappingModal(true);
                        } else {
                            setViewProductMappingModal(false);
                        }
                    }}
                >
                    <ProductMappingWorkspace
                        user={user}
                        repos={productMappingEligibleRepos}
                        sharedRepos={sharedRepos}
                        allReposFilesData={allReposFilesData}
                        productRepoMappings={productRepoMappings}
                        repoHasFileProductMappings={repoHasFileProductMappings}
                        getRepoFilesData={getRepoFilesData}
                        getRepoProductMappings={getRepoProductMappings}
                        isSmallScreen={props.isSmallScreen}
                        onDirtyChange={(dirty) => {
                            setProductMappingHasUnsavedChanges(!!dirty);
                        }}
                    />
                </Modal>
            )}

            {viewRepoWebAccessModal && (
                <Modal
                    title={'Repository Web Access Settings'}
                    titleIcon={faLink}
                    iconColor={'sky'}
                    onClose={() => {
                        if (repoWebAccessHasUnsavedChanges) {
                            setConfirmCloseRepoWebAccessModal(true);
                        } else {
                            setViewRepoWebAccessModal(false);
                        }
                    }}
                >
                    <RepositoryWebAccessSettings
                        user={user}
                        selectedRepo={toRepoWebAccess}
                        sharedRepos={sharedRepos}
                        isSmallScreen={props.isSmallScreen}
                        onDirtyChange={(dirty) => {
                            setRepoWebAccessHasUnsavedChanges(!!dirty);
                        }}
                    />
                </Modal>
            )}

            {confirmCloseRepoWebAccessModal && (
                <ConfirmModal
                    modalText={
                        "You have unsaved changes in 'Repository Web Access Settings'. Are you sure you want to discard them and close?"
                    }
                    onConfirm={() => {
                        setConfirmCloseRepoWebAccessModal(false);
                        setRepoWebAccessHasUnsavedChanges(false);
                        setViewRepoWebAccessModal(false);
                    }}
                    onCancel={() => {
                        setConfirmCloseRepoWebAccessModal(false);
                    }}
                />
            )}

            {confirmCloseProductMappingModal && (
                <ConfirmModal
                    modalText={
                        "You have unsaved changes in 'Product Mapping'. Are you sure you want to discard them and close?"
                    }
                    onConfirm={() => {
                        setConfirmCloseProductMappingModal(false);
                        setProductMappingHasUnsavedChanges(false);
                        setViewProductMappingModal(false);
                    }}
                    onCancel={() => {
                        setConfirmCloseProductMappingModal(false);
                    }}
                />
            )}

            {deleteMode && (
                <ConfirmModal
                    title={'Confirm Delete'}
                    modalText={renderDeleteWarning()}
                    confirmText={'Delete anyway'}
                    onConfirm={async () => await finalizeDelete()}
                    onCancel={() => {
                        setDeleteMode(false);
                        setDeleteImpact(null);
                    }}
                />
            )}

            {showSelectTemplateModal && (
                <Modal
                    title={`Extract '${truncateText(
                        selectedRepoForTemplate.name,
                        20
                    )}' data into db`}
                    titleIcon={faDatabase}
                    iconColor={'blue'}
                    onClose={() => {
                        setShowSelectTemplateModal(false);
                        setSelectedRepoForTemplate(null);
                    }}
                >
                    <ExtractData
                        templateList={templateList}
                        repoName={selectedRepoForTemplate.name}
                        repoId={selectedRepoForTemplate.repoid}
                        email={selectedRepoForTemplate.email}
                        socket={props.socket}
                        currentTemplate={currentTemplate}
                        getAllReposData={getAllReposData}
                        onClose={() => {
                            setShowSelectTemplateModal(false);
                            setSelectedRepoForTemplate(null);
                        }}
                        fetchDownloadList={fetchDownloadList}
                    />
                </Modal>
            )}

            {showReRunExtractionModal && (
                <Modal
                    title={`Re-run Extraction for '${truncateText(
                        selectedRepoForReRun.name,
                        10
                    )}'`}
                    titleIcon={faSync}
                    iconColor={'green'}
                    onClose={() => {
                        setShowReRunExtractionModal(false);
                        setSelectedRepoForReRun(null);
                    }}
                >
                    {currentTemplate ? (
                        <ExtractData
                            templateList={templateList}
                            currentTemplate={currentTemplate}
                            repoName={selectedRepoForReRun.name}
                            repoId={selectedRepoForReRun.repoid}
                            email={selectedRepoForReRun.email}
                            socket={props.socket}
                            getAllReposData={getAllReposData}
                            onClose={() => {
                                setShowReRunExtractionModal(false);
                                setSelectedRepoForReRun(null);
                            }}
                            fetchDownloadList={fetchDownloadList}
                            isReRun={true}
                        />
                    ) : (
                        <div className='p-4 text-center'>
                            No template has been selected for this repository.
                            Please run an extraction with a template first.
                        </div>
                    )}
                </Modal>
            )}

            {showTelegramForm && (
                <Modal
                    title={`Enable Telegram Bot`}
                    titleIcon={faTelegram}
                    iconColor={'blue'}
                    onClose={() => {
                        const data = {
                            userMail: user.email,
                            repoName: selectRepoForTelegram.name,
                            repoId: selectRepoForTelegram.repoid,
                        };
                        props.socket.emit(
                            TelegramSocketEvent.DELETE_USER_SESSION,
                            data
                        );

                        setShowTelegramForm(false);

                        // Refresh virtual repos list in Configure Repository modal
                        if (virtualRepoRefreshRef.current) {
                            virtualRepoRefreshRef.current();
                        }
                    }}
                >
                    <TelegramFormView
                        user={user}
                        repository={selectRepoForTelegram}
                        socket={props.socket}
                        setShowTelegramForm={setShowTelegramForm}
                        getAllReposData={getAllReposData}
                        onRefreshVirtualRepos={() => {
                            if (virtualRepoRefreshRef.current) {
                                virtualRepoRefreshRef.current();
                            }
                        }}
                    />
                </Modal>
            )}

            {showTelegramDetails && (
                <Modal
                    title={`Telegram Details`}
                    titleIcon={faTelegram}
                    iconColor={'blue'}
                    onClose={() => {
                        setShowTelegramDetails(false);

                        // Refresh virtual repos list in Configure Repository modal
                        if (virtualRepoRefreshRef.current) {
                            virtualRepoRefreshRef.current();
                        }
                    }}
                >
                    <TelegramDetails
                        user={user}
                        repository={selectRepoForTelegram}
                    />
                </Modal>
            )}

            {showWhatsAppPanel && (
                <Modal
                    title="WhatsApp Business"
                    titleIcon={faWhatsapp}
                    iconColor={'#25D366'}
                    onClose={() => setShowWhatsAppPanel(false)}
                >
                    <WhatsAppCard
                        user={user}
                        orgId={memberOrgId}
                        contextRepo={selectedRepoForWhatsApp}
                    />
                </Modal>
            )}

            {emailInterfaceModal && (
                <Modal
                    title={'Configure Email Interface'}
                    titleIcon={faEnvelope}
                    iconColor={'blue'}
                    onClose={() => {
                        setEmailInterfaceModal(false);
                    }}
                >
                    <EmailInterface
                        repo={selectedRepoForEmail}
                        onClose={() => {
                            setEmailInterfaceModal(false);
                            setSelectedRepoForEmail(null);
                        }}
                        user={user}
                        emailInterfaceList={emailInterfaceList}
                        getAllReposData={getAllReposData}
                    />
                </Modal>
            )}

            {questionsModalOpen && (
                <Modal
                    title={'Generate Questions'}
                    titleIcon={faQuestionCircle}
                    iconColor={'blue'}
                    onClose={() => setQuestionsModalOpen(false)}
                >
                    <QuestionsModal
                        open={questionsModalOpen}
                        onClose={() => setQuestionsModalOpen(false)}
                        repoId={selectedRepoId.repoId}
                        fileName={selectedRepoId.fileName}
                    />
                </Modal>
            )}
        </div>
    );
};

export default Sidebar;
